import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

export const generatePDF = ({ no, template, element }) => {
  const imgWidth =
    template?.size === 'POS' ? 80 : template?.size === 'A5' ? 148 : 210;
  const pageHeight = 297;

  const input = document.getElementById(element);
  html2canvas(input, {
    logging: true,
    useCORS: true,
  }).then((canvas) => {
    const imgHeight = (canvas.height * imgWidth) / canvas.width;
    let heightLeft = imgHeight;
    let position = 0;
    heightLeft -= pageHeight;
    const doc = new jsPDF('p', 'mm', 'a4');
    doc.addImage(canvas, 'PNG', 0, position, imgWidth, imgHeight, '', 'FAST');
    while (heightLeft >= 0) {
      position = heightLeft - imgHeight;
      doc.addPage();
      doc.addImage(canvas, 'PNG', 0, position, imgWidth, imgHeight, '', 'FAST');
      heightLeft -= pageHeight;
    }
    doc.save(`invoice-${no}.pdf`);
    // const imgData = canvas.toDataURL('image/jpeg', 0.8);
    // const pdf = new jsPDF('p', 'mm');
    // pdf.addImage(imgData, 'jpg', 0, 0, imgWidth, imgHeight);
    // pdf.save(`invoice-${row?.docNo}.pdf`);
  });
};

export const handleDownloadPDF = async (componentRef: any) => {
  const input = componentRef.current;
  if (!input) return;

  const imgWidth = 210;
  const pageHeight = 297;
  html2canvas(input, {
    logging: true,
    useCORS: true,
  }).then((canvas) => {
    const imgHeight = (canvas.height * imgWidth) / canvas.width;
    let heightLeft = imgHeight;
    let position = 0;
    heightLeft -= pageHeight;
    const doc = new jsPDF('p', 'mm', 'a4');
    doc.addImage(canvas, 'PNG', 0, position, imgWidth, imgHeight, '', 'FAST');
    while (heightLeft >= 0) {
      position = heightLeft - imgHeight;
      doc.addPage();
      doc.addImage(canvas, 'PNG', 0, position, imgWidth, imgHeight, '', 'FAST');
      heightLeft -= pageHeight;
    }
    doc.save(`contract-report.pdf`);
    // const imgData = canvas.toDataURL('image/jpeg', 0.8);
    // const pdf = new jsPDF('p', 'mm');
    // pdf.addImage(imgData, 'jpg', 0, 0, imgWidth, imgHeight);
    // pdf.save(`invoice-${row?.docNo}.pdf`);
  });
};

// Generate PDF and return as Blob for upload
export const generatePDFBlob = async (
  componentRef: any,
  filename?: string,
): Promise<{ blob: Blob; filename: string } | null> => {
  const input = componentRef.current;
  if (!input) return null;

  const imgWidth = 210;
  const pageHeight = 297;

  try {
    const canvas = await html2canvas(input, {
      logging: false,
      useCORS: true,
    });

    const imgHeight = (canvas.height * imgWidth) / canvas.width;
    let heightLeft = imgHeight;
    let position = 0;
    heightLeft -= pageHeight;
    const doc = new jsPDF('p', 'mm', 'a4');
    doc.addImage(canvas, 'PNG', 0, position, imgWidth, imgHeight, '', 'FAST');
    while (heightLeft >= 0) {
      position = heightLeft - imgHeight;
      doc.addPage();
      doc.addImage(canvas, 'PNG', 0, position, imgWidth, imgHeight, '', 'FAST');
      heightLeft -= pageHeight;
    }

    const pdfBlob = doc.output('blob');
    const pdfFilename = filename || `document-${Date.now()}.pdf`;

    return { blob: pdfBlob, filename: pdfFilename };
  } catch (error) {
    console.error('Error generating PDF:', error);
    return null;
  }
};

// Generate PDF and upload to S3/Spaces
export const generateAndUploadPDF = async ({
  componentRef,
  filename,
  getPresignedURL,
  basePath,
}: {
  componentRef: any;
  filename?: string;
  getPresignedURL: (variables: { filename: string; filetype: string }) => Promise<any>;
  basePath: string;
}): Promise<{ url: string; filename: string; size: number } | null> => {
  try {
    const result = await generatePDFBlob(componentRef, filename);
    if (!result) return null;

    const { blob, filename: pdfFilename } = result;
    const timestamp = Date.now();
    const path = `${basePath}/${timestamp}_${pdfFilename}`;

    // Get presigned URL
    const res = await getPresignedURL({ filename: path, filetype: 'application/pdf' });
    const signedUrl = res?.data?.getPresignedURL?.data;

    if (!signedUrl) {
      throw new Error('Failed to get upload URL');
    }

    // Upload PDF to S3/Spaces
    const uploadRes = await fetch(signedUrl, {
      method: 'PUT',
      body: blob,
      headers: {
        'Content-Type': 'application/pdf',
        'x-amz-acl': 'public-read',
      },
    });

    if (!uploadRes.ok) {
      throw new Error('Upload failed');
    }

    // Extract the public URL
    const publicUrl = signedUrl.split('?')[0];

    return {
      url: publicUrl,
      filename: pdfFilename,
      size: blob.size,
    };
  } catch (error) {
    console.error('Error generating and uploading PDF:', error);
    return null;
  }
};
